import { useEffect } from 'react'
import Select from 'react-select'
import { SectorDDLAPI, WardNameDDLAPI, WardNameGDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const WardNameGDDL = (props) => {
    const { WardName, setWardName, M_ProjectTypeID, M_ZoneID, rowData, APIFlag, IsPost, Flag, IsDisabled } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName?.ID ?? 0,
            M_ZoneID: M_ZoneID,
            M_ProjectTypeID: M_ProjectTypeID,
            Flag: APIFlag,
            M_UserID: UserID,
            token: token
        }
        dispatch(WardNameGDDLAPI({ data }))
    }, [WardName.ID, M_ZoneID, M_ProjectTypeID])

    const { WardNameGDDLDataa } = useSelector(state => state.WardNameGDDLData)

    useEffect(() => {
        handleWardNameDDL()
    }, [WardNameGDDLDataa])

    const handleWardNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (WardNameGDDLDataa && WardNameGDDLDataa.table && WardNameGDDLDataa.table.length > 0) {
            let list = WardNameGDDLDataa.table.map((item, index) => ({
                value: item.m_WardID,
                label: item.wardName,
            }))

            // setWardName({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_gD_SectorID : 0,
            //     Label: Flag === 'Update' ? rowData.sectorName : "Select...",
            // })
            setWardName({ ...WardName, DDL: list })
        }
        else {
            setWardName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name {Flag && <AstricSign />}</b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                isDisabled={IsDisabled}
                maxMenuHeight={150}
                value={{ value: WardName.ID, label: WardName.Label }}
                onChange={(e) => {
                    e ?
                        setWardName({ ...WardName, ID: e.value, Label: e.label })
                        :
                        setWardName({ ...WardName, ID: 0, Label: "Select..." })

                }}
                options={WardName.DDL}
            />
        </div>
    )
}